module.exports = __webpack_public_path__ + "fa585b4fcb1282681d7944be6b416c6e.svg";